// src/app/services/erWheelApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IErWheel, IErWheelParams, IIdNameValue, UpdatePayload } from '../models';

export const erWheelApi = createApi({
  reducerPath: 'erWheelApi',
  baseQuery,
  endpoints: (builder) => ({
    getErWheelParams: builder.query<{ er_wheel: IErWheelParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/energy_wheels/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getFlowTypes: builder.query<IIdNameValue[], void>({
      query: () => `/api/v1.0/master/v1.0.0/ahu/energy_wheels/flow_types/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getFanLocations: builder.query<IIdNameValue[], void>({
      query: () => `/api/v1.0/master/v1.0.0/ahu/energy_wheels/fan_locations/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getErWheel: builder.query<IErWheel, number>({
      query: (id) => `/api/v1.0/ahu/energy_wheels/${id}`,
    }),
    getErWheelCertifications: builder.query<IIdNameValue[], number>({
      query: (id) => `/api/v1.0/ahu/energy_wheels/${id}/certifications/`,
    }),
    getSeriesIdsByMfgId: builder.query<number[], number>({
      query: (mfg_id) => `/api/v1.0/cms/1/v1.0.0/ahu/energy_wheels/params/series_id/?mfg_id=${mfg_id}`,
    }),
    getTypeIdsByMfgIdAndSeriesId: builder.query<IIdNameValue[], { mfg_id: number; series_id: number }>({
      query: ({ mfg_id, series_id }) => `/api/v1.0/master/v1.0.0/ahu/energy_wheels/type/?mfg_id=${mfg_id}&series_id=${series_id}`,
    }),
    getRotorStylesByMfgIdAndSeriesId: builder.query<IIdNameValue[], { mfg_id: number; series_id: number }>({
      query: ({ mfg_id, series_id }) => `/api/v1.0/master/v1.0.0/ahu/energy_wheels/rotor_style/?mfg_id=${mfg_id}&series_id=${series_id}`,
    }),
    // Mutations
    createEnergyWheel: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/energy_wheels/`,
        method: 'POST',
        body,
        signal,
      }),
    }),
    updateEnergyWheel: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal , id}) => ({
        url: `/api/v1.0/ahu/energy_wheels/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetErWheelQuery,
  useLazyGetErWheelCertificationsQuery,
  useGetFlowTypesQuery,
  useGetFanLocationsQuery,
  useGetErWheelParamsQuery,
  useGetSeriesIdsByMfgIdQuery,
  useGetTypeIdsByMfgIdAndSeriesIdQuery,
  useGetRotorStylesByMfgIdAndSeriesIdQuery,
  useCreateEnergyWheelMutation,
} = erWheelApi;
